import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class ShifttitleController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "shifttitle";
    this.walkthroughState = WALKTHROUGH_STATES.SHIFT_TITLE;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.autoFocus = false;

    this.API_FIELDS = "name";

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.saveTitle();
    });

    this.LockLeftPanelListener = this.$rootScope.$on("LockLeftPanel", ($event, params) => {
      this.disableAllowedLinks();
    });

    this.UnLockLeftPanelListener = this.$rootScope.$on("UnLockLeftPanel", ($event, params) => {
      this.enableAllowedLinks();
    });

    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
    this.$scope.$on("$destroy", this.LockLeftPanelListener);
    this.$scope.$on("$destroy", this.UnLockLeftPanelListener);
  }

  $onInit() {
    this.eraseDefaultName();
    this.syncWithApi();
    this.blurElement();
  }

  blurElement() {
    this.$timeout(() => {
      $(document.activeElement).blur();
      this.focusEle();
    }, 100);
  }

  focusEle() {
    this.$timeout(() => {
      const el = document.getElementById("job-post-job-title");
      el.focus();
    }, 100);
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  enableAllowedLinks() {
    this.$timeout(() => {
      $(".post-a-shift-container .main-next-button").removeClass("disabled");
    });
  }

  disableAllowedLinks() {
    console.log("disableAllowedLinks");
    //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
  }

  syncWithApi() {
    //this.setLoader();
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      this.event.shift_title = data.data.name;
      this.eraseDefaultName();
      //this.unSetLoader();
    });
  }

  eraseDefaultName() {
    if (this.event && this.event.shift_title === "DEFAULT_EVENT_TITLE") {
      this.event.shift_title = "";
    }
  }

  validate() {
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  saveTitle() {
    this.$events.saveEventName(this.event.id, this.event.shift_title).then((data) => {
      this.$tracking.reportPostAJobSubmitStep("job title");
      console.log("Saved shift title:", data);
    });
  }

  goNext() {
    this.saveTitle();
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }
}

ShifttitleController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default ShifttitleController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/shifttitle/shifttitle.controller.js